import React from 'react';
import PropTypes from 'prop-types';
import PositionListButton from "../Buttons/PositionListButton";
import {getStyle} from "../../services/Style";

export default class PositionExpiredInvalid extends React.PureComponent {

    static propTypes = {
        customerName: PropTypes.string.isRequired,
        positionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        language: PropTypes.string.isRequired,
        reason: PropTypes.string
    };

    static defaultProps = {
        reason: null,
        positionId: null
    };

    render() {
        return (
            <div className="section-padding-bottom alice-bg flexHeight">
                <div className="alice-bg padding-top-30 section-padding-bottom flexHeight2"
                     style={getStyle(this.props.positionId, 'backgroundColor', this.props.customerName)}>
                    <div className="container">
                        <div className="row">
                            <div className="col">
                                <div className="job-listing-details job-detail-position">
                                    <div className="section-padding-30">
                                        <div className="row">
                                            <div className="col-12">
                                                <h4 class={"d-block text-center padding-bottom-40"}>{window.Translator.getSlug( this.props.reason === 'expired' ? 'JobOfferIsExpired' : 'JobOfferDoesNotExist', this.props.language)}</h4>
                                            </div>
                                            <div className={"col-12 col-lg-4 offset-lg-4 padding-bottom-40"}>
                                                <PositionListButton
                                                    positionId={this.props.positionId}
                                                    language={this.props.language}
                                                    customerName = {this.props.customerName}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
